// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isBaseOptionProps(option) {
  return !('options' in option);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isAccordionOptionProps(option) {
  return 'options' in option && option['type'] === 'collapse';
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isNextListOptionProps(option) {
  return 'options' in option && option['type'] === 'next-list';
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isGroupOptionProps(option) {
  return 'options' in option && option['type'] === 'group';
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isFieldSelectMultipleProps(props) {
  return 'selection' in props && props['selection'] === 'multiple';
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isFieldSelectSingleProps(props) {
  return 'selection' in props && props['selection'] === 'single' || props['selection'] === undefined;
}